import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import withStyles, { css } from '@bd/bdui-styles';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { userLogout } from '@bd/bdcore-data/build/User/actions';
import withData from '@bd/bdcore-data';
import { colors } from '../styles';
import ReportForm from './ReportForm';
import ResidentTable from './ResidentTable';

const styles = css`
p{
  font-size: 18px;
  letter-spacing: 1.1px;
}
  h2 {
    font-weight:700;
  }
  a {
    color:${colors.color1};
    font-weight:700;
  }
  li a {
    color: white;
  }

  .portalWrap {
    max-width: 1460px;
  }
  .portalActive {
    margin-bottom:20px;
    padding-bottom:10px;
    font-size:24px;
    border-bottom:1px solid #ccc;
    display:block;
    width:100%;
  }
  .portalNav {
    padding:0;
    li {
      padding:5px;
      border-top:1px solid ${colors.color4Lightest};
      span {
        font-weight:700;
        cursor:pointer;
      }
    }
    li:last-child {
      padding:5px;
      border-bottom:1px solid ${colors.color4Lightest};
    }
  }
  .portalDocs {
    li {
      background-color:whitesmoke;
      padding:10px;
      border-radius:4px;
      margin:4px 0;
      a {
        width:100%;
        display:block;
        padding:10px 25px;
        font-size:16px;
        background-image: url('/images/icon-pdf-portal.svg'), url('/images/icon-download-arrow.svg');
        background-position: left, right;
        background-repeat: no-repeat, no-repeat;
        background-size:16px,16px;
        color:${colors.color1};

        /* @media (min-width: 768px) {
          width:100%;
          display:block;
          padding:10px 50px;
          font-size:24px;
          background-image: url('/images/icon-pdf-portal.svg'), url('/images/icon-download-arrow.svg');
          background-position: left, right;
          background-repeat: no-repeat, no-repeat;
          background-size:34px,34px;
          color:${colors.color1};
        } */
      }
    }
  }
  .HOAPortal_needApproval{
  }
  .breakit {
    word-break:break-all;
  }
  .HOAPortal_formWrapper{
    margin: 70px 0;
    padding: 20px;
    background-color: ${colors.other};
  }
`;

const residentPage = {
  title: 'Resident Directory',
  residentPortal: true,
};

class HOAPortal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: this.getInitialPage(),
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.hoaPortal !== prevProps.hoaPortal) {
      this.setActivePage();
    }
  }

  setActivePage = page => () => {
    this.setState({
      activePage: page || this.getInitialPage(),
    });
  }

  getInitialPage() {
    return _.get(this.props, 'hoaPortal.pages', [])
      .find(page => _.get(page, 'title', '').toLowerCase().includes('home'));
  }

  render() {
    const { dispatch, hoaPortal } = this.props;
    const activePage = this.state.activePage || this.getInitialPage();
    return (
      <div className={styles}>
        <div className="container portalWrap">
          <div className="row pt-5">
            <div className="col-12 col-md-3">
              {
                hoaPortal &&
                <h2>Residents</h2>
              }
              <ul className="list-unstyled portalNav">
                {
                  _.get(hoaPortal, 'pages', []).map(page => (
                    <li key={page.title}>
                      <span className={`${activePage === page ? 'active' : ''}`} onClick={this.setActivePage(page)} role="button" tabIndex="0">{page.title}</span>
                    </li>
                ))
                }
                <li>
                  <span className={`${activePage === residentPage ? 'active' : ''}`} onClick={this.setActivePage(residentPage)} role="button" tabIndex="0">{residentPage.title}</span>
                </li>
                <li>
                  <span className="GoldText" role="button" tabIndex="0" onClick={() => dispatch(userLogout())}>Logout</span>
                </li>
              </ul>
            </div>
            <div className="col-12 col-md-9">
              {
                !hoaPortal &&
                <div className="HOAPortal_needApproval mb-5">
                  <h3 className="GoldText">{'Thanks for registering!'}</h3>
                  {'HOA Portal access requires manual approval, you will receive an email notification when your access has been approved.'}
                </div>
              }
              {
                activePage &&
                <strong dangerouslySetInnerHTML={SanitizeHtml(_.get(activePage, 'title'))} className="portalActive" />
              }
              {
                activePage &&
                _.get(activePage, 'body_copy') &&
                <div dangerouslySetInnerHTML={SanitizeHtml(_.get(activePage, 'body_copy'))} />
              }
              {
                activePage && (activePage.title === 'Home' || activePage.title === 'Property Report') &&
                <div className="HOAPortal_formWrapper">
                  <ReportForm noRedirect />
                </div>
              }
              {
                activePage &&
                activePage.residentPortal &&
                <div className="row">
                  <div className="col-12">
                    <ResidentTable residents={_.get(hoaPortal, 'residents', [])} />
                  </div>
                </div>
              }
              <ul className="list-unstyled portalDocs">
                {
                  _.get(activePage, 'attachments', []).map(attachment => (
                    <li key={attachment.title}>
                      <a
                        href={attachment.contentUrl}
                        target="_blank"
                        download
                      >
                        {attachment.title || attachment.contentUrl}
                      </a>
                    </li>
                    ))
                  }
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

HOAPortal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  hoaPortal: PropTypes.object,
};

HOAPortal.defaultProps = {
  hoaPortal: undefined,
};

export default withData(
  { hoaPortal: true, user: true },
  { required: { user: true } },
)(withStyles(styles)(HOAPortal));



// WEBPACK FOOTER //
// ./src/bdcoreCandidates/HOAPortal.js